module.exports = __webpack_public_path__ + "img/support.3b081cd4.svg";